"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=corporate-agreement.dto.js.map